<template>
  <div>
    <avue-crud ref="crud" :option="option" :data="data" @row-save="rowSave" @row-update="rowUpdate" @refresh-change="refresh">
      <template slot-scope="{type, size, row, index}" slot="menu">
        <el-button icon="el-icon-top" :size="size" :type="type" @click.stop="upRow(row, index)" />
        <el-button icon="el-icon-edit" :size="size" :type="type" @click.stop="handleEdit(row, index)" />
        <el-button icon="el-icon-delete" :size="size" :type="type" @click.stop="rowDel(row, index)" />
      </template>
    </avue-crud>
  </div>
</template>

<script>
import { deepClone } from '@/framework/util/util.js'
export default {
  props: ['fieldAttrList', 'fieldDicData'],
  data() {
    return {
      data: this.fieldAttrList,
      option: {
        page: false,
        refreshBtn: false,
        columnBtn: false,
        editBtn: false,
        delBtn: false,
        align: 'center',
        menuAlign: 'center',
        menuWidth: 88,
        column: [
          {
            label: '字段',
            prop: 'fieldName',
            type: 'select',
            dicData: this.fieldDicData || [],
            formatter: (row, value) => {
              // return value ? '显示' : '隐藏'
              for (let i = 0; i < this.fieldDicData.length; i++) {
                if (this.fieldDicData[i].value === value) {
                  return this.fieldDicData[i].label
                }
              }
            },
            rules: [{
              required: true,
              message: '请选择字段',
              trigger: 'blur'
            }]
          }, {
            label: '列显示',
            prop: 'display',
            type: 'select',
            dicData: [
              { label: '是', value: 'true' },
              { label: '仅pc', value: 'pc' },
              { label: '仅手机', value: 'mobile' },
              { label: '否', value: 'false' }
            ],
            formatter: (row, value) => {
              // return value ? '显示' : '隐藏'
              if (value === 'true') {
                return '显示'
              } else if (value === 'pc') {
                return '仅pc'
              } else if (value === 'mobile') {
                return '仅手机'
              } else {
                return '隐藏'
              }
            },
            cell: true,
            width: 60,
            value: 'true'
          },
          {
            label: '字段类型',
            prop: 'fieldType',
            type: 'select',
            dicData: [
              { label: '关键字(如:value,id)', value: 'key' },
              { label: '显示名称(如:label,name)', value: 'name' },
              { label: '显示名称及关键字', value: 'keyAndName' },
              { label: '普通字段', value: 'other' }
            ],
            formatter: (row, value) => {
              if (value === 'key') {
                return '关键字'
              } else if (value === 'name') {
                return '显示名称'
              } else if (value === 'keyAndName') {
                return '名称及关键字'
              } else {
                return '普通字段'
              }
            },
            cell: true,
            width: 75,
            value: 'other'
          },
          {
            label: '查询方式',
            prop: 'queryType',
            type: 'select',
            dicData: [
              { label: '无', value: 'none' },
              { label: '精确', value: '=' },
              { label: '模糊', value: 'like' }
            ],
            hide: true,
            value: 'none'
          },
          {
            label: '排序方式',
            prop: 'orderType',
            type: 'select',
            dicData: [
              { label: '无', value: 'none' },
              { label: '正序', value: 'asc' },
              { label: '倒序', value: 'desc' }
            ],
            hide: true,
            value: 'none'
          },
          {
            label: '排序优先级',
            prop: 'orderPriority',
            type: 'number',
            hide: true,
            value: 0
          },
          {
            label: '回填字段',
            prop: 'callIdName',
            type: 'input',
            hide: true,
            value: ''
          },
          {
            label: '回填方式',
            prop: 'callIdMethod',
            type: 'select',
            dicData: [
              { label: '默认', value: 'default' },
              { label: '字符串', value: 'string' },
              { label: '数组', value: 'array' }
            ],
            hide: true,
            value: 'default'
          }
        ]
      }
    }
  },
  methods: {
    rowSave(form, done, loading) {
      // if (form.display !== false) {
      //   form.display = true
      // }
      // this.$message.success('新增数据'+ JSON.stringify(form))
      done(form)
      this.$emit('replaceData', this.data)
    },
    refresh(val) {
      this.$message.success('刷新回调,当前分页对象' + JSON.stringify(val))
    },
    rowDel(form, index) {
      // this.$message.success('删除数据'+ JSON.stringify(form) + index);
      this.fieldAttrList.splice(index, 1)
    },
    rowUpdate(form, index, done, loading) {
      // if (form.display !== false) {
      //   form.display = true
      // }
      const {
        display,
        fieldName,
        fieldType,
        queryType,
        orderType,
        orderPriority,
        callIdName,
        callIdMethod
      } = form
      this.fieldAttrList[index].display = display
      this.fieldAttrList[index].fieldName = fieldName
      this.fieldAttrList[index].fieldType = fieldType
      this.fieldAttrList[index].queryType = queryType
      this.fieldAttrList[index].orderType = orderType
      this.fieldAttrList[index].orderPriority = orderPriority
      this.fieldAttrList[index].callIdName = callIdName
      this.fieldAttrList[index].callIdMethod = callIdMethod
      this.$emit('replaceData', this.data)
      done()
    },
    handleEdit(row, index) {
      this.$refs.crud.rowEdit(row, index)
    },
    upRow(row, index) {
      if (index === 0) {
        return
      }
      let item = deepClone(this.fieldAttrList[index])
      let itemPre = deepClone(this.fieldAttrList[index - 1])

      this.fieldAttrList[index - 1].display = item.display
      this.fieldAttrList[index - 1].fieldName = item.fieldName
      this.fieldAttrList[index - 1].fieldType = item.fieldType
      this.fieldAttrList[index - 1].queryType = item.queryType
      this.fieldAttrList[index - 1].orderType = item.orderType
      this.fieldAttrList[index - 1].orderPriority = item.orderPriority
      this.fieldAttrList[index - 1].callIdName = item.callIdName
      this.fieldAttrList[index - 1].callIdMethod = item.callIdMethod

      this.fieldAttrList[index].display = itemPre.display
      this.fieldAttrList[index].fieldName = itemPre.fieldName
      this.fieldAttrList[index].fieldType = itemPre.fieldType
      this.fieldAttrList[index].queryType = itemPre.queryType
      this.fieldAttrList[index].orderType = itemPre.orderType
      this.fieldAttrList[index].orderPriority = itemPre.orderPriority
      this.fieldAttrList[index].callIdName = itemPre.callIdName
      this.fieldAttrList[index].callIdMethod = itemPre.callIdMethod
    }
  },
  watch: {
    fieldDicData(val) {
      this.option.column[0].dicData = val
    }
  }
}
</script>
